<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{on}"> 
      <v-btn
        color="primary"
        v-on="on"
      > 
        Month End Closing Report
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Batch Reports"
      text="Generate Month End Closing Report"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col cols="12">
            <span class="font-weight-bold summary-header-font-size">Choose report types to generate:</span>
          </v-col>
          <v-col
            cols="6"
            class="py-0"
          >
            <v-checkbox
              v-model="payrollCompanySummary"
              label="Company Summary"
            />
          </v-col>
          <v-col
            cols="6"
            class="py-0"
          >
            <v-checkbox
              v-model="payrollCompany"
              label="Company"
            />
          </v-col>
          <!-- <v-col
            cols="6"
            class="py-0"
          >
            <v-checkbox
              v-model="payrollBranchSummary"
              label="Branches Summary"
            />
          </v-col>
          <v-col
            cols="6"
            class="py-0"
          >
            <v-checkbox
              v-model="payrollBranch"
              label="Branches"
            />
          </v-col> -->
          <v-col
            cols="6"
            class="py-0"
          >
            <v-checkbox
              v-model="paymentMethodSummary"
              label="Payment Method Summary"
            />
          </v-col>
          <v-col
            cols="6"
            class="py-0"
          >
            <v-checkbox
              v-model="paymentMethod"
              label="Payment Method"
            />
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="!(payrollCompanySummary || payrollCompany || payrollBranch || payrollBranchSummary || payrollBranchSummary || paymentMethodSummary || paymentMethod)"
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Generate
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      company: {
        type: String,
        required: true,
      },
      salarymonth: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        payrollCompanySummary: false,
        payrollCompany: false,
        payrollBranchSummary: false,
        payrollBranch: false,
        paymentMethodSummary: false,
        paymentMethod: false,
      }
    },

    methods: {
      submitForm () {
        this.progressing = true
        this.$api.companySalaryBatch().downloadClosingReport(this.prepareFormData())
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', '[' + this.company.name + '] Month End Closing Report - ' + this.salarymonth + '.xlsx') 
            link.click()

            this.payrollCompanySummary = false
            this.payrollCompany = false
            this.payrollBranchSummary = false
            this.payrollBranch = false
            this.paymentMethodSummary = false
            this.paymentMethod = false

            this.progressing = false
            this.dialog = false
          })
      },
      prepareFormData () {
        return {
          salaryMonth: this.salarymonth, 
          company_uid: this.company.id,
          payrollCompanySummary: this.payrollCompanySummary,
          payrollCompany: this.payrollCompany,
          payrollBranchSummary: this.payrollBranchSummary,
          payrollBranch: this.payrollBranch,
          paymentMethodSummary: this.paymentMethodSummary,
          paymentMethod: this.paymentMethod,
        }
      },
    },
  }
</script>
